import { render, staticRenderFns } from "./MenuBox.vue?vue&type=template&id=b70be0aa&scoped=true&"
import script from "./MenuBox.vue?vue&type=script&lang=js&"
export * from "./MenuBox.vue?vue&type=script&lang=js&"
import style0 from "./MenuBox.vue?vue&type=style&index=0&id=b70be0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70be0aa",
  null
  
)

export default component.exports